import { render, staticRenderFns } from "./CelMoney.vue?vue&type=template&id=5125feb1&functional=true&"
import script from "./CelMoney.vue?vue&type=script&lang=js&"
export * from "./CelMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports